<template>
  <div
    class="relative w-full border border-light/40 bg-base-100 rounded-xl p-4 flex flex-col gap-4 transition hover:bg-base-200 group cursor-pointer"
    @click="handleClick"
  >
    <div class="flex flex-col items-center justify-center text-center gap-2">
      <!-- Icon box -->
      <div class="text-xl text-light shadow-sm shadow-light rounded-lg py-2 px-3 transition group-hover:text-accent">
        <i class="bi bi-box"></i>
      </div>

      <!-- Text -->
      <p class="text-sm text-base-content transition">
        Click to <span class="font-medium text-accent group-hover:underline">{{ actionText }}</span>
      </p>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  actionText: {
    type: String,
    default: 'Add a new product'
  }
})

const emit = defineEmits(['clicked'])

function handleClick() {
  emit('clicked')
}
</script>